var rtlLanguages = ['ar', 'ur'];

var getIsRtl = function getIsRtl() {
  var isRtl = false;
  var locale = navigator.language.split('-')[0] || 'en';

  if (rtlLanguages.includes(locale)) {
    isRtl = true;
  }

  return isRtl;
};

export var isRtl = getIsRtl();
export function handleRTL(rtl) {
  if (rtl !== undefined) {
    document.dir = rtl ? 'rtl' : 'ltr';
    return;
  }

  var locale = navigator.language.split('-')[0] || 'en';

  if (rtlLanguages.includes(locale)) {
    document.dir = 'rtl';
  }
}